/*** IMPORTS FROM imports-loader ***/
var define = false;

import trashIcon from '@SvgIcon/trash-b.svg'

// import { Dashboard } from '@uppy/vue'
import Uppy from '@uppy/core'
import AwsS3 from '@uppy/aws-s3'
import svgIconHtml from '../../svgIconHtml'

/**
 * Copied from Vue 3 project. Not ported completely for Vue 2 yet.
 *
 * -- Remaining: --
 *
 * Import styles:
 * <style src="@uppy/core/dist/style.css"></style>
 * <style src="@uppy/dashboard/dist/style.css"></style>
 *
 * Upgrade Uppy from 1.x to 2.x, upgrading existing Uppy integrations.
 */

export default {
  name: 'UiFormUppy',

  components: {
    // UppyDashboard: Dashboard,
    UppyDashboard: {},
  },

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  inject: {
    ngForm: {
      default: '',
    },
  },

  template: `
    <div class="ui-input">
    <input
        v-if="formFieldName"
        type="hidden"
        :name="formFieldName"
        :value="valueAsJson"
    />

    <div
        v-if="valueArray.length"
        class="warning callout"
        style="font-size: 14px; color: #000;"
    >
      <b>Files uploaded:</b>
      <ul style="margin-top: 0; margin-bottom: 0;">
        <li v-for="(val, idx) in valueArray" :key="idx">
          {{ val }}
          <button
              type="button"
              class="clear button alert"
              aria-label="Remove"
              @click="removeFile(val)"
          >
            ${svgIconHtml(trashIcon)}
          </button>
        </li>
      </ul>
    </div>

    <uppy-dashboard
        :uppy="uppy"
        :props="{ theme: 'light' }"
    />
    </div>
  `,

  props: {
    modelValue: {
      type: Array,
      default() {
        return []
      },
    },
    paramsUrl: {
      type: String,
      required: true,
    },
    formFieldName: {
      type: String,
    },
    allowMultiple: {
      type: Boolean,
      default: false,
    },
    minNumFiles: {
      type: Number,
      default: 0,
    },
    maxNumFiles: {
      type: Number,
    },
    allowedTypes: {
      type: Array,
    },
  },

  data() {
    return {
      uppy: null,
    }
  },

  computed: {
    valueArray() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue
      }
      if (this.modelValue) {
        return [this.modelValue]
      }
      return []
    },

    valueAsJson() {
      return JSON.stringify(this.valueArray)
    },

    shouldShowUploader() {
      if (!this.allowMultiple && this.valueArray.length > 0) {
        return false
      }
      return true
    },
  },

  methods: {
    removeFile(val) {
      let values = this.valueArray.slice()
      const idx = values.indexOf(val)
      if (idx !== -1) {
        values.splice(idx, 1)
        this.modelValue = values
        this.$emit('update:modelValue', values)
      }
    },
  },

  beforeDestroy() {
    this.uppy.close()
  },

  created() {
    const uppy = new Uppy({
      debug: true,
      autoProceed: false,
      allowMultipleUploads: this.maxNumFiles !== 1,
      restrictions: {
        // bytes = {X}MB * 1E+6;  1E+6 === 1,000,000
        maxFileSize: 50 * 1000000,
        maxNumberOfFiles: this.maxNumFiles,
        minNumberOfFiles: this.minNumFiles,
        allowedFileTypes: this.allowedTypes,
      },
    }).use(AwsS3, {
      getUploadParameters: (file) => {
        return fetch(this.paramsUrl, {
          method: 'post',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            filename: file.name,
            contentType: file.type,
          }),
        })
          .then(response => response.json())
          .then((data) => {
            if ('error' in data) {
              alert(data.error)
              return false
            }
            return {
              method: data.method,
              url: data.url,
              fields: data.fields,
            }
          })
      },
    })

    uppy.on('upload-success', (file) => {
      let values = this.valueArray.slice()
      if (!this.allowMultiple) {
        values = [file.meta.filename]
      } else {
        values.push(file.meta.filename)
      }
      this.$emit('update:modelValue', values)
    })

    this.uppy = uppy
  },
}

